import {HttpClient, HttpHandler} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {AdumoEftPaymentUpdateRequest} from "../../interfaces/adumoeft/Adumoeft";

@Injectable()

export class AdumoeftApi extends HttpClient {
    private baseUrl = environment.production ? "/channel-virtual/api/v1" + '/stitch' : environment.baseUrl + '/stitch';

    public constructor(handler: HttpHandler) {
      super(handler);
    }

    public initializePayment(sessionToken: string): Observable<any> {
      const url = this.baseUrl + `/initialize?sessionToken=${sessionToken}`;
      return super.post(url, "");
    }

    public getTransactionStatus(sessionToken: string, adumoEftPaymentUpdateRequest: AdumoEftPaymentUpdateRequest): Observable<object> {
      const url = this.baseUrl + `/status?sessionToken=${sessionToken}`;
      return super.post(url, adumoEftPaymentUpdateRequest);
    }

}
